// Campus photo for /colleges/belmont-university: CC BY-SA 2.0, by Warren LeMay from Chicago, IL, United States, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABelmont_Mansion_(Acklen_Hall)%2C_Belmont_University%2C_Belmont_Boulevard%2C_Edgehill%2C_Nashville%2C_TN_(54385065781).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/belmont-university/; credited under the photo.
const photo = {
    "slug": "belmont-university",
    "alt": "Belmont Mansion, also called Acklen Hall, on the Belmont University campus in Nashville, Tennessee",
    "src": "/colleges/belmont-university/campus-1600.webp",
    "srcSmall": "/colleges/belmont-university/campus-800.webp",
    "srcMid": "/colleges/belmont-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/belmont-university/og.jpg",
    "title": "Belmont Mansion (Acklen Hall), Belmont University, Belmont Boulevard, Edgehill, Nashville, TN (54385065781)",
    "author": "Warren LeMay from Chicago, IL, United States",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABelmont_Mansion_(Acklen_Hall)%2C_Belmont_University%2C_Belmont_Boulevard%2C_Edgehill%2C_Nashville%2C_TN_(54385065781).jpg",
    "read": "2026-10-01"
};

export default photo;
